import { useWindowDimensions } from "react-native";

import { layout } from "@passfirst/ui";

// Responsive helpers for the web/wide layouts (design_handoff_2).
//   - Rule A: focused (<900) → split (≥900) for practice/diagnostic;
//     paywall stacks→row at 760.
//   - Rule B: bottom tab bar (<900) → 236px left sidebar (≥900).
//
// On native this returns the device width, which is always < 900 on
// phones, so the narrow branch is taken — the wide layouts only ever
// engage on web/tablet/desktop. Screens that need container-relative
// width (a screen inset inside a larger window) can pass an onLayout
// width to `isWideWidth` instead of relying on the window.

export interface Responsive {
  width: number;
  /** ≥ 900 — Rule A split / Rule B sidebar engage. */
  isWide: boolean;
  /** ≥ 760 — paywall switches stacked→side-by-side. */
  isPaywallWide: boolean;
}

export function useResponsive(): Responsive {
  const { width } = useWindowDimensions();
  return {
    width,
    isWide: width >= layout.splitBreakpoint,
    isPaywallWide: width >= layout.paywallBreakpoint,
  };
}

/** Container-relative variant of Rule A's split breakpoint. */
export function isWideWidth(width: number): boolean {
  return width >= layout.splitBreakpoint;
}
